// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"-kTHq","hidden":"_2DsJc","timeWrapper":"hvoBS","time":"_3jtKW","duration":"_1vYE0","liveMode":"wKNbg","separator":"_2ueiP"};